import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

// Lichte huisstijl. Dark mode later = dit object swappen (of via CSS-vars).
const C = {
  bg:'#f3f4f6', card:'#ffffff', card2:'#f9fafb', line:'#e5e7eb', lineStrong:'#d1d5db',
  text:'#111827', muted:'#6b7280', muted2:'#9ca3af',
  primary:'#4f46e5', primaryH:'#4338ca', primarySoft:'#eef2ff',
  brand:'#00D4AA', brandL:'#00E8BB', okBg:'#ecfdf5', okLine:'#10b981', danger:'#dc2626'
};

export default function ServicedeskApp() {
  const { gebruiker, logout, hasPermission } = useAuth();
  const magBeheer = hasPermission('servicedesk:beheer');
  const magLezen  = hasPermission('servicedesk:lezen');
  const magBinnen = magLezen || magBeheer;
  const [tab, setTab] = useState('melden');
  if (!magBinnen) {
    return (
      <div style={{ minHeight:'100vh', background:C.bg, color:C.text, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'-apple-system,Segoe UI,Roboto,sans-serif', padding:24 }}>
        <div style={{ textAlign:'center', maxWidth:420 }}>
          <div style={{ fontSize:48, marginBottom:12 }}>⛔</div>
          <h2 style={{ margin:'0 0 8px', fontSize:20 }}>Geen toegang tot de servicedesk</h2>
          <p style={{ color:C.muted, fontSize:14, margin:'0 0 20px' }}>Je account heeft geen servicedesk-rechten. Neem contact op met je beheerder als dit onjuist is.</p>
          <button onClick={logout} style={{ padding:'10px 20px', border:'none', background:C.primary, color:'#fff', borderRadius:8, fontWeight:600, cursor:'pointer' }}>Uitloggen</button>
        </div>
      </div>
    );
  }
  return (
    <div style={{ minHeight:'100vh', background:C.bg, color:C.text, fontFamily:'-apple-system,Segoe UI,Roboto,sans-serif' }}>
      <div style={{ maxWidth:1280, margin:'0 auto', padding:'24px 28px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <div style={{ width:38, height:38, borderRadius:10, background:`linear-gradient(135deg,${C.brand},${C.brandL})`, display:'flex', alignItems:'center', justifyContent:'center', color:'#04201a', fontWeight:800, fontSize:18 }}>W</div>
            <div><b style={{ fontSize:17 }}>Servicedesk</b><div style={{ fontSize:11.5, color:C.muted }}>WOMsys</div></div>
          </div>
          <div style={{ textAlign:'right', fontSize:12.5, color:C.muted }}>
            <b style={{ color:C.text, display:'block', fontSize:13.5 }}>{gebruiker?.voornaam} {gebruiker?.achternaam}</b>
            <span onClick={logout} style={{ cursor:'pointer' }}>uitloggen</span>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 560px', minWidth: 0 }}>
            <div style={{ display:'flex', gap:6, background:C.card, border:`1px solid ${C.line}`, borderRadius:12, padding:5, marginBottom:24, boxShadow:'0 1px 3px rgba(0,0,0,.05)' }}>
              {[['storingen','🛠 Storingen'],['melden','＋ Melden'],...(magBeheer?[['instellingen','⚙ Instellingen']]:[])].map(([k,l]) => (
                <div key={k} onClick={() => setTab(k)} style={{ flex:1, textAlign:'center', padding:10, borderRadius:8, fontSize:13.5, fontWeight:600, cursor:'pointer', color: tab===k?C.primary:C.muted, background: tab===k?C.primarySoft:'transparent' }}>{l}</div>
              ))}
            </div>
            {tab==='melden' && <Melden />}
            {tab==='storingen' && <Storingen />}
            {tab==='instellingen' && magBeheer && <Instellingen />}
          </div>
          <aside style={{ flex: '1 1 300px', minWidth: 280, maxWidth: 360 }}>
            <Diensten />
          </aside>
        </div>
      </div>
    </div>
  );
}


function Storingen() {
  const [lijst, setLijst] = useState([]);
  const [afdelingen, setAfdelingen] = useState([]);
  const [filt, setFilt] = useState(null);
  const [sel, setSel] = useState(null);
  const [detail, setDetail] = useState(null);
  const [laden, setLaden] = useState(true);

  const load = () => { setLaden(true); api.get('/servicedesk/storingen').then(r => { setLijst(r.data.storingen||[]); setLaden(false); }).catch(()=>setLaden(false)); };
  useEffect(() => { load(); api.get('/servicedesk/afdelingen').then(r=>setAfdelingen(r.data.afdelingen||[])); }, []);
  useEffect(() => {
    if (sel==null) { setDetail(null); return; }
    setDetail(null);
    api.get('/servicedesk/storing/'+sel).then(r=>setDetail(r.data)).catch(()=>setDetail({error:true}));
  }, [sel]);

  const view = filt ? lijst.filter(s=>s.afdeling_id===filt) : lijst;
  const dt = (v) => v ? new Date(v).toLocaleString('nl-NL',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}) : '';
  const naam = (o) => o ? (o.naam || ((o.voornaam||'')+' '+(o.achternaam||'')).trim()) : '';

  const badge = (st) => {
    const m = { nieuw:['#6b7280','#f3f4f6'], gemeld:['#6b7280','#f3f4f6'], open:['#4f46e5','#eef2ff'],
      toegewezen:['#b45309','#fef3c7'], gezien:['#b45309','#fef3c7'], opgepakt:['#0369a1','#e0f2fe'],
      onderweg:['#0369a1','#e0f2fe'], ter_plaatse:['#0369a1','#e0f2fe'], opgelost:['#047857','#ecfdf5'], afgerond:['#047857','#ecfdf5'] };
    const [c,b] = m[st] || ['#6b7280','#f3f4f6'];
    return { color:c, background:b, padding:'3px 10px', borderRadius:20, fontSize:11.5, fontWeight:600, textTransform:'capitalize', whiteSpace:'nowrap' };
  };
  const slaBadge = (s) => {
    if (!s.sla) return null;
    const m = { ok:['#047857','#ecfdf5','SLA ✓'], warn:['#b45309','#fef3c7','SLA ⚠'], over:['#b91c1c','#fee2e2','SLA ✕'],
      gehaald:['#047857','#ecfdf5','SLA ✓'], overschreden:['#b91c1c','#fee2e2','SLA ✕'] };
    const [c,b,t] = m[s.sla] || [];
    if (!t) return null;
    let rest = '';
    if (s.sla==='ok' || s.sla==='warn' || s.sla==='over') {
      const doel = s.eerste_reactie ? s.sla_herstel_minuten : s.sla_reactie_minuten;
      if (doel) {
        const verstreken = (Date.now() - new Date(s.created_at).getTime()) / 60000;
        const over = Math.round(doel - verstreken);
        const fmt = (mi) => { const am = Math.abs(mi); return am >= 60 ? Math.round(am/60) + 'u' : am + 'm'; };
        rest = over >= 0 ? ' ' + fmt(over) : ' +' + fmt(over);
      }
    }
    return <span style={{ color:c, background:b, padding:'3px 10px', borderRadius:20, fontSize:11.5, fontWeight:600, whiteSpace:'nowrap' }}>{t}{rest}</span>;
  };
  const card = { background:C.card, border:`1px solid ${C.line}`, borderRadius:12, boxShadow:'0 1px 3px rgba(0,0,0,.05)' };

  if (sel != null) {
    const s = detail?.storing;
    const tl = detail?.tijdlijn || [];
    const hist = detail?.historie || [];
    return (
      <div>
        <div onClick={()=>setSel(null)} style={{ cursor:'pointer', color:C.primary, fontSize:13.5, fontWeight:600, marginBottom:16 }}>← terug naar overzicht</div>
        {!detail && <div style={{ color:C.muted2, padding:'40px 0', textAlign:'center' }}>laden…</div>}
        {detail?.error && <div style={{ color:C.danger }}>Kon storing niet laden.</div>}
        {s && (
          <>
            <div style={{ ...card, padding:'18px 20px', marginBottom:16 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
                <h1 style={{ fontSize:19 }}>#{s.id} · {s.titel}</h1>
                <span style={badge(s.status)}>{s.status}</span>
              </div>
              <div style={{ color:C.muted, fontSize:13.5, marginTop:8, display:'flex', gap:16, flexWrap:'wrap' }}>
                <span>Afdeling: <b style={{ color:C.text }}>{s.afdeling_naam || '—'}</b></span>
                <span>Prioriteit: <b style={{ color:C.text }}>{s.prioriteit || '—'}</b></span>
                {s.werkorder_id && <span>Werkorder: <b style={{ color:C.text }}>#{s.werkorder_id}</b></span>}
                <span>Gemeld: <b style={{ color:C.text }}>{dt(s.created_at)}</b></span>
              </div>
              {s.beschrijving && <p style={{ marginTop:12, fontSize:14, color:C.text }}>{s.beschrijving}</p>}
            </div>
            {(detail?.fotos || []).length > 0 && (
              <div style={{ ...card, padding:'18px 20px', marginBottom:16 }}>
                <h2 style={{ fontSize:15, marginBottom:12 }}>Foto's ({detail.fotos.length})</h2>
                <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
                  {detail.fotos.map(f => (
                    <a key={f.id} href={f.url} target="_blank" rel="noreferrer">
                      <img src={f.url} alt="" style={{ width:110, height:110, objectFit:'cover', borderRadius:10, border:`1px solid ${C.line}` }} />
                    </a>
                  ))}
                </div>
              </div>
            )}
            <div style={{ ...card, padding:'18px 20px' }}>
              <h2 style={{ fontSize:15, marginBottom:14 }}>Tijdlijn</h2>
              {tl.length===0 && <div style={{ color:C.muted2, fontSize:13.5 }}>Nog geen status-updates.</div>}
              {tl.map((it,i) => (
                <div key={i} style={{ display:'flex', gap:12, paddingBottom:14, marginBottom:14, borderBottom: i<tl.length-1?`1px solid ${C.line}`:'none' }}>
                  <div style={{ width:9, height:9, borderRadius:9, background:C.primary, marginTop:5, flexShrink:0 }} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13.5, fontWeight:600, textTransform:'capitalize' }}>{it.status}</div>
                    {it.opmerking && <div style={{ fontSize:13, color:C.muted, marginTop:2 }}>{it.opmerking}</div>}
                    <div style={{ fontSize:11.5, color:C.muted2, marginTop:3 }}>{naam(it)} · {dt(it.created_at)}</div>
                  </div>
                </div>
              ))}
            </div>
            {hist.length > 0 && (
              <div style={{ ...card, padding:'18px 20px', marginTop:16 }}>
                <h2 style={{ fontSize:15, marginBottom:4 }}>Eerdere storingen object</h2>
                <div style={{ fontSize:12, color:C.muted2, marginBottom:12 }}>{hist.length} eerdere melding{hist.length===1?'':'en'} op dit object</div>
                {hist.map((h,i) => (
                  <div key={h.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, paddingBottom:12, marginBottom:12, borderBottom: i<hist.length-1?`1px solid ${C.line}`:'none' }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:13.5, fontWeight:600, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>#{h.id} · {h.titel}</div>
                      <div style={{ fontSize:11.5, color:C.muted2, marginTop:2 }}>{dt(h.created_at)}{h.prioriteit ? ' · ' + h.prioriteit : ''}</div>
                    </div>
                    <span style={badge(h.status)}>{h.status}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, flexWrap:'wrap', gap:10 }}>
        <h1 style={{ fontSize:21 }}>Storingen</h1>
        <div onClick={load} style={{ cursor:'pointer', color:C.primary, fontSize:13, fontWeight:600 }}>↻ ververs</div>
      </div>
      <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
        {[{id:null,naam:'Alle'},...afdelingen].map(a => (
          <div key={a.id??'all'} onClick={()=>setFilt(a.id)} style={{ padding:'7px 14px', borderRadius:20, fontSize:13, cursor:'pointer', fontWeight:600,
            background: filt===a.id?C.primary:'#fff', color: filt===a.id?'#fff':C.muted, border:`1px solid ${filt===a.id?C.primary:C.line}` }}>{a.naam}</div>
        ))}
      </div>
      <MiniAnalyse afdelingId={filt} />
      {laden && <div style={{ color:C.muted2, padding:'40px 0', textAlign:'center' }}>laden…</div>}
      {!laden && view.length===0 && <div style={{ color:C.muted2, padding:'40px 0', textAlign:'center' }}>Geen storingen.</div>}
      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {view.map(s => (
          <div key={s.id} onClick={()=>setSel(s.id)} style={{ ...card, padding:'14px 18px', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', gap:12 }}>
            <div style={{ minWidth:0 }}>
              <div style={{ fontSize:14.5, fontWeight:600, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>#{s.id} · {s.titel}</div>
              <div style={{ fontSize:12.5, color:C.muted, marginTop:3 }}>{s.afdeling_naam || '—'}{s.werkorder_id?` · WO #${s.werkorder_id}`:''} · {dt(s.created_at)}</div>
            </div>
            <div style={{ display:'flex', gap:6, alignItems:'center', flexShrink:0 }}>
              {slaBadge(s)}
              <span style={badge(s.status)}>{s.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


function SlaBeheer() {
  const [rijen, setRijen] = useState([]);
  const [edit, setEdit] = useState({});
  const [busy, setBusy] = useState(null);
  const load = () => api.get('/servicedesk/beheer/sla').then(r => setRijen(r.data.sla || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const wijzig = (id, veld, waarde) => setEdit(e => ({ ...e, [id]: { ...(e[id] || {}), [veld]: waarde } }));
  const opslaan = async (rij) => {
    const e = edit[rij.id] || {};
    setBusy(rij.id);
    try {
      await api.put('/servicedesk/beheer/sla/' + rij.id, {
        reactie_minuten: e.reactie_minuten ?? rij.reactie_minuten,
        herstel_minuten: e.herstel_minuten ?? rij.herstel_minuten
      });
      setEdit(x => { const c = { ...x }; delete c[rij.id]; return c; });
      await load();
    } catch (err) {}
    setBusy(null);
  };
  if (!rijen.length) return null;
  const card2 = { background: C.card, border: `1px solid ${C.line}`, borderRadius: 12, padding: '16px 18px', marginBottom: 20, boxShadow: '0 1px 3px rgba(0,0,0,.05)' };
  const inp2 = { border: `1px solid ${C.line}`, borderRadius: 8, padding: '6px 8px', fontSize: 13, width: 70 };
  const groepen = {};
  rijen.forEach(r => { (groepen[r.afdeling_naam] = groepen[r.afdeling_naam] || []).push(r); });
  return (
    <div style={card2}>
      <h2 style={{ fontSize: 16, marginBottom: 4 }}>SLA-normen</h2>
      <div style={{ fontSize: 12.5, color: C.muted2, marginBottom: 12 }}>Reactie- en hersteltijd in minuten, per afdeling en prioriteit.</div>
      {Object.entries(groepen).map(([afd, rs]) => (
        <div key={afd} style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, marginBottom: 6 }}>{afd}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {rs.map(r => {
              const e = edit[r.id] || {};
              const gewijzigd = e.reactie_minuten != null || e.herstel_minuten != null;
              return (
                <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 13, width: 70, textTransform: 'capitalize', fontWeight: 600 }}>{r.prioriteit}</span>
                  <label style={{ fontSize: 12, color: C.muted2 }}>reactie</label>
                  <input style={inp2} type="number" min="1" value={e.reactie_minuten ?? r.reactie_minuten} onChange={ev => wijzig(r.id, 'reactie_minuten', ev.target.value)} />
                  <label style={{ fontSize: 12, color: C.muted2 }}>herstel</label>
                  <input style={inp2} type="number" min="1" value={e.herstel_minuten ?? r.herstel_minuten} onChange={ev => wijzig(r.id, 'herstel_minuten', ev.target.value)} />
                  {gewijzigd && <button onClick={() => opslaan(r)} disabled={busy === r.id} style={{ background: C.primary, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>{busy === r.id ? '...' : 'Opslaan'}</button>}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

function EscalatieBeheer() {
  const [rijen, setRijen] = useState([]);
  const [edit, setEdit] = useState({});
  const [busy, setBusy] = useState(null);
  const load = () => api.get('/servicedesk/beheer/escalatie').then(r => setRijen(r.data.escalatie || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const wijzig = (id, veld, waarde) => setEdit(e => ({ ...e, [id]: { ...(e[id] || {}), [veld]: waarde } }));
  const opslaan = async (rij) => {
    const e = edit[rij.id] || {};
    setBusy(rij.id);
    try {
      await api.put('/servicedesk/beheer/escalatie/' + rij.id, {
        herinner_minuten: e.herinner_minuten ?? rij.herinner_minuten,
        escalatie_minuten: e.escalatie_minuten ?? rij.escalatie_minuten,
        escalatie_naar: e.escalatie_naar ?? rij.escalatie_naar,
        actief: e.actief ?? rij.actief
      });
      setEdit(x => { const c = { ...x }; delete c[rij.id]; return c; });
      await load();
    } catch (err) {}
    setBusy(null);
  };
  if (!rijen.length) return null;
  const card2 = { background: C.card, border: `1px solid ${C.line}`, borderRadius: 12, padding: '16px 18px', marginBottom: 20, boxShadow: '0 1px 3px rgba(0,0,0,.05)' };
  const inp2 = { border: `1px solid ${C.line}`, borderRadius: 8, padding: '6px 8px', fontSize: 13, width: 70 };
  return (
    <div style={card2}>
      <h2 style={{ fontSize: 16, marginBottom: 4 }}>Escalatie</h2>
      <div style={{ fontSize: 12.5, color: C.muted2, marginBottom: 12 }}>Bij niet-accepteren: eerst herinnering naar dezelfde ontvangers, daarna escalatie. Minuten na melding.</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {rijen.map(r => {
          const e = edit[r.id] || {};
          const gewijzigd = Object.keys(e).length > 0;
          const naar = e.escalatie_naar ?? r.escalatie_naar;
          const aan = e.actief ?? r.actief;
          return (
            <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13, width: 90, fontWeight: 700 }}>{r.afdeling_naam}</span>
              <label style={{ fontSize: 12, color: C.muted2 }}>herinner</label>
              <input style={inp2} type="number" min="1" value={e.herinner_minuten ?? r.herinner_minuten} onChange={ev => wijzig(r.id, 'herinner_minuten', ev.target.value)} />
              <label style={{ fontSize: 12, color: C.muted2 }}>escaleer</label>
              <input style={inp2} type="number" min="2" value={e.escalatie_minuten ?? r.escalatie_minuten} onChange={ev => wijzig(r.id, 'escalatie_minuten', ev.target.value)} />
              <label style={{ fontSize: 12, color: C.muted2 }}>naar</label>
              <select style={{ ...inp2, width: 150 }} value={naar} onChange={ev => wijzig(r.id, 'escalatie_naar', ev.target.value)}>
                <option value="afdeling">hele afdeling</option>
                <option value="werkvoorbereiders">werkvoorbereiders</option>
              </select>
              <div onClick={() => wijzig(r.id, 'actief', !aan)} style={{ cursor: 'pointer', fontSize: 11.5, fontWeight: 600, padding: '3px 10px', borderRadius: 20,
                background: aan ? '#ecfdf5' : '#f3f4f6', color: aan ? '#047857' : '#6b7280' }}>{aan ? 'actief' : 'uit'}</div>
              {gewijzigd && <button onClick={() => opslaan(r)} disabled={busy === r.id} style={{ background: C.primary, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>{busy === r.id ? '...' : 'Opslaan'}</button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function RapportBlok() {
  const [afdelingen, setAfdelingen] = useState([]);
  const [afdId, setAfdId] = useState('');
  const nu = new Date();
  const vorige = new Date(nu.getFullYear(), nu.getMonth() - 1, 1);
  const [jaar, setJaar] = useState(vorige.getFullYear());
  const [maand, setMaand] = useState(vorige.getMonth() + 1);
  const [busy, setBusy] = useState(false);
  const [fout, setFout] = useState('');
  const [mailRijen, setMailRijen] = useState([]);
  const [mailEdit, setMailEdit] = useState({});
  const [mailBusy, setMailBusy] = useState(null);
  const loadMail = () => api.get('/servicedesk/beheer/rapport').then(r => setMailRijen(r.data.rapport || [])).catch(() => {});
  useEffect(() => { api.get('/servicedesk/afdelingen').then(r => setAfdelingen(r.data.afdelingen || [])).catch(() => {}); loadMail(); }, []);
  const mailWijzig = (id, veld, waarde) => setMailEdit(e => ({ ...e, [id]: { ...(e[id] || {}), [veld]: waarde } }));
  const mailOpslaan = async (rij) => {
    const e = mailEdit[rij.id] || {};
    setMailBusy(rij.id);
    try {
      await api.put('/servicedesk/beheer/rapport/' + rij.id, {
        email_naar: e.email_naar ?? rij.email_naar,
        actief: e.actief ?? rij.actief
      });
      setMailEdit(x => { const c = { ...x }; delete c[rij.id]; return c; });
      await loadMail();
    } catch (err) {}
    setMailBusy(null);
  };
  const MND = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
  const download = async () => {
    if (!afdId) return;
    setBusy(true); setFout('');
    try {
      const r = await api.get('/servicedesk/maandrapport', { params: { afdeling_id: afdId, jaar, maand }, responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `servicedesk-rapport-${jaar}-${String(maand).padStart(2,'0')}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) { setFout('Kon rapport niet genereren.'); }
    setBusy(false);
  };
  const card2 = { background: C.card, border: `1px solid ${C.line}`, borderRadius: 12, padding: '16px 18px', marginBottom: 20, boxShadow: '0 1px 3px rgba(0,0,0,.05)' };
  const inp2 = { border: `1px solid ${C.line}`, borderRadius: 8, padding: '7px 10px', fontSize: 13 };
  return (
    <div style={card2}>
      <h2 style={{ fontSize: 16, marginBottom: 4 }}>Maandrapport</h2>
      <div style={{ fontSize: 12.5, color: C.muted2, marginBottom: 12 }}>PDF met storingen, SLA-scores, hersteltijd en top-objecten per afdeling.</div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <select style={inp2} value={afdId} onChange={e => setAfdId(e.target.value)}>
          <option value="">— afdeling —</option>
          {afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)}
        </select>
        <select style={inp2} value={maand} onChange={e => setMaand(+e.target.value)}>
          {MND.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
        </select>
        <select style={inp2} value={jaar} onChange={e => setJaar(+e.target.value)}>
          {[nu.getFullYear(), nu.getFullYear() - 1].map(j => <option key={j} value={j}>{j}</option>)}
        </select>
        <button onClick={download} disabled={!afdId || busy} style={{ background: C.primary, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: (!afdId || busy) ? 0.6 : 1 }}>
          {busy ? '...' : '⬇ Download PDF'}
        </button>
      </div>
      {fout && <div style={{ color: C.danger, fontSize: 12.5, marginTop: 8 }}>{fout}</div>}
      <div style={{ borderTop: `1px solid ${C.line}`, marginTop: 14, paddingTop: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 2 }}>Automatisch mailen</div>
        <div style={{ fontSize: 12, color: C.muted2, marginBottom: 10 }}>Elke 1e van de maand om 07:00, rapport over de vorige maand. Meerdere adressen scheiden met komma.</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {mailRijen.map(r => {
            const e = mailEdit[r.id] || {};
            const gewijzigd = Object.keys(e).length > 0;
            const aan = e.actief ?? r.actief;
            return (
              <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 13, width: 90, fontWeight: 700 }}>{r.afdeling_naam}</span>
                <input style={{ border: `1px solid ${C.line}`, borderRadius: 8, padding: '7px 10px', fontSize: 13, flex: '1 1 260px' }}
                  placeholder="email@gvb.nl, tweede@gvb.nl"
                  value={e.email_naar ?? r.email_naar} onChange={ev => mailWijzig(r.id, 'email_naar', ev.target.value)} />
                <div onClick={() => mailWijzig(r.id, 'actief', !aan)} style={{ cursor: 'pointer', fontSize: 11.5, fontWeight: 600, padding: '3px 10px', borderRadius: 20,
                  background: aan ? '#ecfdf5' : '#f3f4f6', color: aan ? '#047857' : '#6b7280' }}>{aan ? 'actief' : 'uit'}</div>
                {gewijzigd && <button onClick={() => mailOpslaan(r)} disabled={mailBusy === r.id} style={{ background: C.primary, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>{mailBusy === r.id ? '...' : 'Opslaan'}</button>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function Instellingen() {
  const [types, setTypes] = useState([]);
  const [afdelingen, setAfdelingen] = useState([]);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [fout, setFout] = useState('');

  const load = () => api.get('/storing-types').then(r => setTypes(r.data.types || []));
  useEffect(() => { load(); api.get('/servicedesk/afdelingen').then(r => setAfdelingen(r.data.afdelingen || [])); }, []);

  const nieuw = () => { setFout(''); setForm({ id:null, naam:'', icoon:'🔧', urgentie:'normaal', scope:'afdeling', afdeling_ids:[], standaard_tekst:'' }); };
  const bewerk = (t) => { setFout(''); setForm({ id:t.id, naam:t.naam, icoon:t.icoon||'🔧', urgentie:t.urgentie, scope:t.scope, afdeling_ids:(t.afdelingen||[]).map(a=>a.id), standaard_tekst:t.standaard_tekst||'' }); };
  const toggleAfd = (id) => setForm(f => {
    if (f.scope==='afdeling') return { ...f, afdeling_ids:[id] };
    const has = f.afdeling_ids.includes(id);
    return { ...f, afdeling_ids: has ? f.afdeling_ids.filter(x=>x!==id) : [...f.afdeling_ids, id] };
  });

  const opslaan = async () => {
    setFout('');
    if (!form.naam.trim()) return setFout('Naam is verplicht');
    if (!form.afdeling_ids.length) return setFout('Kies minstens één afdeling');
    if (form.scope==='afdeling' && form.afdeling_ids.length!==1) return setFout('Een gewoon type hoort bij precies één afdeling');
    setBusy(true);
    try {
      const body = { naam:form.naam.trim(), icoon:form.icoon, urgentie:form.urgentie, scope:form.scope, afdeling_ids:form.afdeling_ids, standaard_tekst:(form.standaard_tekst||'').trim() };
      if (form.id) await api.put('/storing-types/'+form.id, body); else await api.post('/storing-types', body);
      setForm(null); await load();
    } catch (e) { setFout(e.response?.data?.message || 'Fout bij opslaan'); }
    setBusy(false);
  };
  const verwijder = async (t) => {
    if (!window.confirm('Type "'+t.naam+'" verwijderen?')) return;
    try { await api.delete('/storing-types/'+t.id); await load(); } catch (e) {}
  };

  const card = { background:C.card, border:`1px solid ${C.line}`, borderRadius:12, padding:'16px 18px', marginBottom:16, boxShadow:'0 1px 3px rgba(0,0,0,.05)' };
  const inp = { background:'#fff', border:`1px solid ${C.lineStrong}`, borderRadius:9, padding:'10px 12px', color:C.text, fontSize:14, fontFamily:'inherit' };
  const chip = (sel) => ({ padding:'7px 13px', borderRadius:20, fontSize:13, cursor:'pointer', fontWeight:600, background: sel?C.primary:'#fff', color: sel?'#fff':C.muted, border:`1px solid ${sel?C.primary:C.line}` });
  const urg = (st) => ({ color: st==='spoed'?'#b45309':'#6b7280', background: st==='spoed'?'#fef3c7':'#f3f4f6', padding:'2px 9px', borderRadius:20, fontSize:11, fontWeight:600 });
  const lbl = { display:'block', fontSize:12.5, color:C.muted, marginBottom:8, fontWeight:600 };

  const typeRij = (t) => (
    <div key={t.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'9px 0', borderBottom:`1px solid ${C.line}` }}>
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <span style={{ fontSize:17 }}>{t.icoon}</span>
        <span style={{ fontWeight:600, fontSize:14 }}>{t.naam}</span>
        <span style={urg(t.urgentie)}>{t.urgentie}</span>
        {!t.actief && <span style={{ fontSize:11, color:C.muted2 }}>(inactief)</span>}
      </div>
      <div style={{ display:'flex', gap:14, fontSize:13 }}>
        <span onClick={()=>bewerk(t)} style={{ cursor:'pointer', color:C.primary, fontWeight:600 }}>bewerk</span>
        <span onClick={()=>verwijder(t)} style={{ cursor:'pointer', color:C.danger }}>verwijder</span>
      </div>
    </div>
  );

  const calamiteiten = types.filter(t => t.scope==='calamiteit');

  return (
    <div>
      <SlaBeheer />
      <EscalatieBeheer />
      <RapportBlok />
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18, flexWrap:'wrap', gap:10 }}>
        <h1 style={{ fontSize:21 }}>Snel-menu instellingen</h1>
        {!form && <button onClick={nieuw} style={{ background:C.primary, color:'#fff', border:'none', borderRadius:10, padding:'10px 16px', fontSize:13.5, fontWeight:700, cursor:'pointer' }}>＋ Nieuw type</button>}
      </div>

      {form && (
        <div style={{ ...card, border:`1px solid ${C.primary}` }}>
          <h2 style={{ fontSize:16, marginBottom:14 }}>{form.id ? 'Type bewerken' : 'Nieuw type'}</h2>
          {fout && <div style={{ color:C.danger, fontSize:13, marginBottom:12 }}>{fout}</div>}
          <div style={{ display:'flex', gap:12, marginBottom:14, flexWrap:'wrap' }}>
            <div style={{ width:70 }}><label style={lbl}>Icoon</label><input style={{ ...inp, width:'100%', textAlign:'center' }} value={form.icoon} onChange={e=>setForm({...form, icoon:e.target.value})} /></div>
            <div style={{ flex:1, minWidth:200 }}><label style={lbl}>Naam</label><input style={{ ...inp, width:'100%' }} value={form.naam} onChange={e=>setForm({...form, naam:e.target.value})} placeholder="bv. Storing roltrap" /></div>
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={lbl}>Urgentie</label>
            <div style={{ display:'flex', gap:8 }}>
              {['normaal','spoed'].map(u => <div key={u} style={chip(form.urgentie===u)} onClick={()=>setForm({...form, urgentie:u})}>{u}</div>)}
            </div>
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={lbl}>Standaard tekst — komt automatisch bij elke melding van dit type</label>
            <textarea style={{ ...inp, width:'100%', minHeight:70, boxSizing:'border-box' }} value={form.standaard_tekst||''} onChange={e=>setForm({...form, standaard_tekst:e.target.value})} placeholder="bv. Controleer eerst de hoofdschakelaar" />
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={lbl}>Type</label>
            <div style={{ display:'flex', gap:8 }}>
              {['afdeling','calamiteit'].map(s => (
                <div key={s} style={{ ...chip(form.scope===s), opacity: form.id?0.5:1, cursor: form.id?'default':'pointer' }}
                  onClick={()=>{ if(!form.id) setForm({...form, scope:s, afdeling_ids: s==='afdeling'?form.afdeling_ids.slice(0,1):form.afdeling_ids}); }}>
                  {s==='afdeling'?'Eén afdeling':'Calamiteit (meerdere)'}
                </div>
              ))}
            </div>
            {form.id && <div style={{ fontSize:11.5, color:C.muted2, marginTop:6 }}>Type kan na aanmaken niet meer gewijzigd worden.</div>}
          </div>
          <div style={{ marginBottom:16 }}>
            <label style={lbl}>Afdeling{form.scope==='calamiteit'?'en':''}</label>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
              {afdelingen.map(a => <div key={a.id} style={chip(form.afdeling_ids.includes(a.id))} onClick={()=>toggleAfd(a.id)}>{a.naam}</div>)}
            </div>
          </div>
          <div style={{ display:'flex', gap:10 }}>
            <button disabled={busy} onClick={opslaan} style={{ background:C.primary, color:'#fff', border:'none', borderRadius:10, padding:'11px 20px', fontSize:14, fontWeight:700, cursor:'pointer' }}>{busy?'…':'Opslaan'}</button>
            <button onClick={()=>setForm(null)} style={{ background:'#fff', color:C.muted, border:`1px solid ${C.line}`, borderRadius:10, padding:'11px 20px', fontSize:14, fontWeight:600, cursor:'pointer' }}>Annuleren</button>
          </div>
        </div>
      )}

      {afdelingen.map(a => {
        const ts = types.filter(t => t.scope==='afdeling' && (t.afdelingen||[]).some(x=>x.id===a.id));
        return (
          <div key={a.id} style={card}>
            <h2 style={{ fontSize:15, marginBottom:6 }}>{a.naam}</h2>
            {ts.length===0 ? <div style={{ color:C.muted2, fontSize:13.5, padding:'6px 0' }}>Nog geen types.</div> : ts.map(typeRij)}
          </div>
        );
      })}

      <div style={{ ...card, borderLeft:`3px solid #b45309` }}>
        <h2 style={{ fontSize:15, marginBottom:6 }}>🚨 Calamiteiten <span style={{ fontSize:12, color:C.muted2, fontWeight:400 }}>(raken meerdere afdelingen)</span></h2>
        {calamiteiten.length===0 ? <div style={{ color:C.muted2, fontSize:13.5, padding:'6px 0' }}>Nog geen calamiteit-types.</div> : calamiteiten.map(t => (
          <div key={t.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'9px 0', borderBottom:`1px solid ${C.line}` }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:17 }}>{t.icoon}</span>
              <span style={{ fontWeight:600, fontSize:14 }}>{t.naam}</span>
              <span style={{ fontSize:11.5, color:C.muted }}>{(t.afdelingen||[]).map(a=>a.naam).join(', ')}</span>
            </div>
            <div style={{ display:'flex', gap:14, fontSize:13 }}>
              <span onClick={()=>bewerk(t)} style={{ cursor:'pointer', color:C.primary, fontWeight:600 }}>bewerk</span>
              <span onClick={()=>verwijder(t)} style={{ cursor:'pointer', color:C.danger }}>verwijder</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


function MiniAnalyse({ afdelingId }) {
  const [d, setD] = useState(null);
  const [zichtbaar, setZichtbaar] = useState(true);
  useEffect(() => {
    let actief = true;
    const p = { periode: 'maand' };
    if (afdelingId) p.afdeling_id = afdelingId;
    api.get('/analyse/storingen', { params: p })
      .then(r => { if (actief) setD(r.data.data || r.data); })
      .catch(e => { if (actief && e?.response?.status === 403) setZichtbaar(false); });
    return () => { actief = false; };
  }, [afdelingId]);
  if (!zichtbaar || !d) return null;
  const aantal = d.totalen ? +d.totalen.storingen_totaal : null;
  const vorige = +(d.trendVorige?.aantal ?? 0);
  const herstel = d.hersteltijdUren?.uren;
  const trend = vorige > 0 && aantal != null ? Math.round(((aantal - vorige) / vorige) * 100) : null;
  const risico = (d.risicoObjecten || []).slice(0, 3);
  const kpi = { background: '#fff', border: `1px solid ${C.line}`, borderRadius: 10, padding: '10px 14px', flex: '1 1 120px', minWidth: 110 };
  return (
    <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 12, padding: '14px 16px', marginBottom: 16, boxShadow: '0 1px 3px rgba(0,0,0,.05)' }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: C.muted, textTransform: 'uppercase', letterSpacing: .4, marginBottom: 10 }}>Deze maand{afdelingId ? '' : ' · alle afdelingen'}</div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <div style={kpi}>
          <div style={{ fontSize: 21, fontWeight: 700 }}>{aantal ?? '—'}
            {trend != null && <span style={{ fontSize: 12, fontWeight: 600, marginLeft: 6, color: trend > 0 ? '#b91c1c' : '#047857' }}>{trend > 0 ? '▲' : '▼'} {Math.abs(trend)}%</span>}
          </div>
          <div style={{ fontSize: 12, color: C.muted2 }}>storingen</div>
        </div>
        <div style={kpi}>
          <div style={{ fontSize: 21, fontWeight: 700 }}>{herstel != null ? herstel + 'u' : '—'}</div>
          <div style={{ fontSize: 12, color: C.muted2 }}>gem. hersteltijd</div>
        </div>
        {risico.length > 0 && (
          <div style={{ ...kpi, flex: '2 1 220px' }}>
            <div style={{ fontSize: 12, color: C.muted2, marginBottom: 4 }}>risico-objecten</div>
            {risico.map((r, i) => (
              <div key={i} style={{ fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {r.naam || r.object_naam || ('#' + (r.object_id || '?'))} <span style={{ color: C.muted, fontWeight: 400 }}>· {r.aantal}x</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function Diensten() {
  const [data, setData] = useState([]);
  const [laden, setLaden] = useState(true);
  const [busy, setBusy] = useState(null);
  const load = () => { setLaden(true); api.get('/servicedesk/diensten').then(r => { setData(r.data.diensten || []); setLaden(false); }).catch(() => setLaden(false)); };
  useEffect(() => { load(); }, []);
  const toggle = async (id, aanwezig) => {
    setBusy(id);
    try { await api.post('/servicedesk/aanwezig', { gebruiker_id: id, aanwezig }); await load(); } catch (e) {}
    setBusy(null);
  };
  const card = { background: C.card, border: `1px solid ${C.line}`, borderRadius: 12, padding: '16px 18px', marginBottom: 14, boxShadow: '0 1px 3px rgba(0,0,0,.05)' };
  const row = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', gap: 10, flexWrap: 'wrap' };
  const tag = (bg, c) => ({ background: bg, color: c, padding: '2px 10px', borderRadius: 20, fontSize: 11.5, fontWeight: 600 });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 style={{ fontSize: 21 }}>Diensten deze week</h1>
          <p style={{ color: C.muted, fontSize: 13.5, marginTop: 2 }}>🔴 storingsdienst (06:00–21:30) · 🌙 nachtdienst (22:00–06:00). Overdracht 21:30–22:00 — dan staan beide aan.</p>
        </div>
        <div onClick={load} style={{ cursor: 'pointer', color: C.primary, fontSize: 13, fontWeight: 600 }}>↻ ververs</div>
      </div>
      {laden && <div style={{ color: C.muted2, padding: '40px 0', textAlign: 'center' }}>laden…</div>}
      {!laden && data.map(d => (
        <div key={d.afdeling_id} style={card}>
          <h2 style={{ fontSize: 15, marginBottom: 10 }}>{d.afdeling_naam}</h2>
          <div>
            <div style={{ fontSize: 14, marginBottom: 8 }}>🔴 Storingsdienst</div>
            {d.storingsdienst.length === 0 && <div style={{ fontSize: 13.5, color: C.muted2 }}>niemand deze week</div>}
            {d.storingsdienst.map(s => (
              <div key={s.id} style={row}>
                <span style={{ fontSize: 13.5, fontWeight: 600, opacity: s.afwezig ? 0.55 : 1 }}>{s.naam}{s.telefoon ? <span style={{ fontWeight: 400, color: C.muted }}> · {s.telefoon}</span> : ''}</span>
                {s.afwezig ? <span style={tag('#fef3c7', '#b45309')}>{String(s.afwezig).toLowerCase()}</span> : null}
              </div>
            ))}
          </div>
          <div style={{ borderTop: `1px solid ${C.line}`, marginTop: 8, paddingTop: 8 }}>
            <div style={{ fontSize: 14, marginBottom: 8 }}>🌙 Nachtdienst</div>
            {d.nachtdienst.length === 0 && <div style={{ fontSize: 13.5, color: C.muted2 }}>niemand deze week</div>}
            {d.nachtdienst.map(n => (
              <div key={n.id} style={row}>
                <span style={{ fontSize: 13.5, fontWeight: 600 }}>{n.naam}{n.telefoon ? <span style={{ fontWeight: 400, color: C.muted }}> · {n.telefoon}</span> : ''}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {n.afwezig
                    ? <span style={tag('#fef3c7', '#b45309')}>{String(n.afwezig).toLowerCase()}</span>
                    : n.aanwezig
                    ? <span style={tag('#ecfdf5', '#047857')}>aanwezig</span>
                    : <span style={tag('#f3f4f6', '#6b7280')}>niet aanwezig</span>}

                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function Placeholder({ titel }) {
  return <div style={{ textAlign:'center', color:C.muted2, padding:'60px 0', fontSize:14 }}>{titel} — volgende stap.</div>;
}

function ObjectHistorie({ objectId }) {
  const [hist, setHist] = useState([]);
  useEffect(() => {
    let actief = true;
    if (!objectId) { setHist([]); return; }
    api.get('/servicedesk/object-historie', { params: { object_id: objectId } })
      .then(r => { if (actief) setHist(r.data.historie || []); })
      .catch(() => { if (actief) setHist([]); });
    return () => { actief = false; };
  }, [objectId]);
  if (!objectId || !hist.length) return null;
  const dt2 = (v) => new Date(v).toLocaleString('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  return (
    <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 12, padding: '14px 16px', marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#92400e', marginBottom: 8 }}>⚠ Dit object had al {hist.length} eerdere melding{hist.length === 1 ? '' : 'en'}</div>
      {hist.map(h => (
        <div key={h.id} style={{ fontSize: 12.5, color: '#78350f', marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          #{h.id} · {h.titel} <span style={{ opacity: .7 }}>· {h.status} · {dt2(h.created_at)}</span>
        </div>
      ))}
    </div>
  );
}

function GaatNaar({ afdelingId }) {
  const [data, setData] = useState(null);
  const [laden, setLaden] = useState(false);
  useEffect(() => {
    if (!afdelingId) { setData(null); return; }
    let actief = true;
    setLaden(true);
    api.get('/servicedesk/ontvangers', { params: { afdeling_id: afdelingId } })
      .then(r => { if (actief) setData(r.data); })
      .catch(() => { if (actief) setData(null); })
      .finally(() => { if (actief) setLaden(false); });
    return () => { actief = false; };
  }, [afdelingId]);
  if (!afdelingId) return null;
  const bronLabel = data ? (({ storingsdienst:'Storingsdienst', nachtdienst:'Nachtdienst', overlap:'Wachtdienst (overdracht)', afdeling:'Afdeling' })[data.bron] || 'Wachtdienst') : '';
  const cardS = { background:C.card, border:`1px solid ${C.line}`, borderRadius:12, padding:'14px 18px', marginBottom:16, boxShadow:'0 1px 3px rgba(0,0,0,.05)' };
  const initialen = (n) => (n||'').split(' ').filter(Boolean).map(w => w[0]).slice(0,2).join('').toUpperCase();
  return (
    <div style={cardS}>
      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
        <span style={{ fontSize:12.5, color:C.muted, fontWeight:600 }}>Gaat nu naar</span>
        {data && <span style={{ fontSize:11, fontWeight:600, color:C.primary, background:C.primarySoft, padding:'2px 8px', borderRadius:20 }}>{bronLabel}</span>}
      </div>
      {laden && <div style={{ fontSize:13.5, color:C.muted2, paddingTop:8 }}>laden...</div>}
      {!laden && data && data.ontvangers.length === 0 && (
        <div style={{ fontSize:13.5, color:C.muted2, paddingTop:8 }}>Niemand gekoppeld - gaat naar de hele afdeling.</div>
      )}
      {!laden && data && data.ontvangers.map(o => (
        <div key={o.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 0', borderTop:`1px solid ${C.line}` }}>
          <div style={{ width:30, height:30, borderRadius:'50%', background:C.primarySoft, color:C.primary, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11.5, fontWeight:700, flexShrink:0 }}>{initialen(o.naam)}</div>
          <div style={{ fontSize:13.5, color:C.text, fontWeight:500 }}>{o.naam}</div>
          {o.telefoon && <a href={`tel:${o.telefoon}`} style={{ marginLeft:'auto', fontSize:13, color:C.primary, fontWeight:600, textDecoration:'none' }}>{o.telefoon}</a>}
        </div>
      ))}
    </div>
  );
}

function Melden() {
  const [afdelingen, setAfdelingen] = useState([]);
  const [types, setTypes] = useState([]);
  const [objecten, setObjecten] = useState([]);
  const [afd, setAfd] = useState(null);
  const [type, setType] = useState(null);
  const [objId, setObjId] = useState('');
  const [objCat, setObjCat] = useState('');
  const [fotos, setFotos] = useState([]);
  const [oms, setOms] = useState('');
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/servicedesk/afdelingen').then(r => setAfdelingen(r.data.afdelingen || []));
    api.get('/storing-types').then(r => setTypes(r.data.types || []));
  }, []);
  useEffect(() => {
    setType(null); setObjId(''); setObjCat(''); setFotos([]);
    if (afd) api.get('/servicedesk/objecten', { params:{ afdeling_id: afd } }).then(r => setObjecten(r.data.objecten || []));
    else setObjecten([]);
  }, [afd]);

  const afdTypes = types.filter(t => t.scope === 'afdeling' && (t.afdelingen||[]).some(a => a.id === afd));

  const submit = async () => {
    if (!type) return;
    setBusy(true); setResult(null);
    try {
      const fd = new FormData();
      fd.append('storing_type_id', type.id);
      if (objId) fd.append('object_id', objId);
      fd.append('beschrijving', oms);
      fotos.forEach(f => fd.append('fotos', f));
      const r = await api.post('/servicedesk/melding', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setResult(r.data);
      setAfd(null); setType(null); setObjId(''); setOms(''); setFotos([]);
    } catch (e) { setResult({ error: e.response?.data?.message || 'Fout' }); }
    setBusy(false);
  };

  const card = { background:C.card, border:`1px solid ${C.line}`, borderRadius:12, padding:'18px 20px', marginBottom:16, boxShadow:'0 1px 3px rgba(0,0,0,.05)' };
  const inp = { background:'#fff', border:`1px solid ${C.lineStrong}`, borderRadius:9, padding:'11px 12px', color:C.text, fontSize:14, width:'100%', fontFamily:'inherit' };
  const opt = (sel) => ({ background: sel?C.primarySoft:'#fff', border:`1px solid ${sel?C.primary:C.line}`, color: sel?C.primary:C.text, borderRadius:10, padding:'12px 10px', textAlign:'center', cursor:'pointer', fontSize:13.5, fontWeight: sel?600:500 });
  const grid = { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:10 };
  const lbl = { display:'block', fontSize:12.5, color:C.muted, marginBottom:9, fontWeight:600 };

  return (
    <div>
      <h1 style={{ fontSize:21, marginBottom:4 }}>Storing melden</h1>
      <p style={{ color:C.muted, fontSize:14, marginBottom:20 }}>Kies de afdeling en het soort storing. De rest regelt het systeem.</p>

      {result && !result.error && (
        <div style={{ background:C.okBg, border:`1px solid ${C.okLine}`, borderRadius:12, padding:16, marginBottom:18 }}>
          <div style={{ fontSize:14.5, fontWeight:600, marginBottom:10 }}>✓ Storing doorgestuurd</div>
          {result.storingen?.map((s,i) => {
            const afdNaam = (afdelingen.find(a => a.id === s.afdeling_id) || {}).naam || ('afd ' + s.afdeling_id);
            const bronLabel = ({ storingsdienst:'Storingsdienst', nachtdienst:'Nachtdienst', overlap:'Wachtdienst (overdracht)', afdeling:'Afdeling' })[s.bron] || 'Wachtdienst';
            return (
              <div key={i} style={{ background:'#fff', border:`1px solid ${C.line}`, borderRadius:10, padding:'12px 14px', marginBottom:10 }}>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8 }}>
                  <span style={{ fontSize:12.5, color:C.muted }}>#{s.storing_id} · {afdNaam}</span>
                  <span style={{ fontSize:11, fontWeight:600, color:C.primary, background:C.primarySoft, borderRadius:20, padding:'2px 9px' }}>{bronLabel}</span>
                </div>
                {(s.ontvangers || []).map(o => (
                  <div key={o.id} style={{ display:'flex', alignItems:'center', gap:11, padding:'6px 0' }}>
                    <div style={{ width:34, height:34, borderRadius:9, background:C.primarySoft, color:C.primary, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:13, flexShrink:0 }}>{(o.naam || '?').split(' ').map(w => w[0]).slice(0,2).join('').toUpperCase()}</div>
                    <div style={{ minWidth:0, flex:1 }}>
                      <div style={{ fontSize:13.5, fontWeight:600 }}>{o.naam}</div>
                      <div style={{ fontSize:12, color:C.muted }}>{bronLabel}{o.telefoon ? <> · <a href={`tel:${o.telefoon}`} style={{ color:C.primary, textDecoration:'none' }}>{o.telefoon}</a></> : ''}</div>
                    </div>
                  </div>
                ))}
                {(s.ontvangers || []).length === 0 && <div style={{ fontSize:12.5, color:C.muted2 }}>geen ontvanger gevonden</div>}
              </div>
            );
          })}
        </div>
      )}
      {result?.error && <div style={{ color:C.danger, marginBottom:14 }}>{result.error}</div>}

      <div style={card}>
        <label style={lbl}>Afdeling</label>
        <div style={grid}>
          {afdelingen.map(a => <div key={a.id} style={opt(afd===a.id)} onClick={() => setAfd(a.id)}>{a.naam}</div>)}
        </div>
      </div>

      <GaatNaar afdelingId={afd} />
      {afd && (
        <>
          <div style={card}>
            <label style={lbl}>Soort storing</label>
            <div style={grid}>
              {afdTypes.map(t => <div key={t.id} style={opt(type?.id===t.id)} onClick={() => setType(t)}>{t.icoon} {t.naam}<div style={{ fontSize:11, color:C.muted2, fontWeight:400 }}>{t.urgentie}</div></div>)}
              {afdTypes.length===0 && <div style={{ gridColumn:'1/-1', color:C.muted2, fontSize:13.5 }}>Nog geen types voor deze afdeling — voeg ze toe bij Instellingen.</div>}
            </div>
          </div>
          <div style={card}>
            <label style={lbl}>Object / locatie</label>
            {(() => {
              const cats = [...new Set(objecten.map(o => o.categorie || 'Overig'))];
              const meerdere = cats.length > 1;
              const zichtbaar = meerdere ? objecten.filter(o => (o.categorie || 'Overig') === objCat) : objecten;
              return (
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {meerdere && (
                    <select style={{ ...inp, flex: '1 1 160px' }} value={objCat} onChange={e => { setObjCat(e.target.value); setObjId(''); }}>
                      <option value="">— categorie —</option>
                      {cats.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  )}
                  <select style={{ ...inp, flex: '2 1 220px' }} value={objId} onChange={e => setObjId(e.target.value)} disabled={meerdere && !objCat}>
                    <option value="">{meerdere && !objCat ? '— eerst categorie —' : '— kies object —'}</option>
                    {zichtbaar.map(o => <option key={o.id} value={o.id}>{o.naam}{o.locatie?` · ${o.locatie}`:''}</option>)}
                  </select>
                </div>
              );
            })()}
          </div>
          <ObjectHistorie objectId={objId} />
          <div style={{ ...card, padding:'16px 18px', marginBottom:16 }}>
            <label style={lbl}>Foto's (optioneel, max 5)</label>
            <input type="file" accept="image/*" multiple
              onChange={e => setFotos(Array.from(e.target.files || []).slice(0, 5))}
              style={{ fontSize: 13 }} />
            {fotos.length > 0 && (
              <div style={{ display:'flex', gap:8, marginTop:10, flexWrap:'wrap' }}>
                {fotos.map((f, i) => (
                  <div key={i} style={{ position:'relative' }}>
                    <img src={URL.createObjectURL(f)} alt="" style={{ width:64, height:64, objectFit:'cover', borderRadius:8, border:`1px solid ${C.line}` }} />
                    <div onClick={() => setFotos(fs => fs.filter((_, x) => x !== i))}
                      style={{ position:'absolute', top:-6, right:-6, background:'#b91c1c', color:'#fff', width:18, height:18, borderRadius:9, fontSize:11, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>×</div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={card}>
            {type?.standaard_tekst && <div style={{ background:C.primarySoft, border:`1px solid ${C.line}`, borderRadius:9, padding:'10px 12px', marginBottom:12, fontSize:13.5, color:C.text, whiteSpace:'pre-wrap' }}><div style={{ fontSize:11.5, color:C.muted, fontWeight:600, marginBottom:4 }}>Standaardtekst (gaat automatisch mee)</div>{type.standaard_tekst}</div>}
            <label style={lbl}>Extra informatie (optioneel)</label>
            <textarea style={{ ...inp, minHeight:80 }} value={oms} onChange={e => setOms(e.target.value)} placeholder="Extra toelichting bovenop de standaardtekst (optioneel)" />
          </div>
          <button disabled={!type || busy} onClick={submit}
            onMouseOver={e=>{ if(type) e.currentTarget.style.background=C.primaryH; }}
            onMouseOut={e=>{ if(type) e.currentTarget.style.background=C.primary; }}
            style={{ background: type?C.primary:C.muted2, color:'#fff', border:'none', borderRadius:11, padding:15, fontSize:15, fontWeight:700, cursor: type?'pointer':'default', width:'100%' }}>
            {busy ? '…' : 'Storing doorsturen'}
          </button>
        </>
      )}
    </div>
  );
}
